import React, { useState, useEffect } from 'react';
import ReactTooltip from 'react-tooltip';
import KrService from '../../services/kr.service';
import { imgUrl } from '../../../utils/url';

const service = new KrService();

const Okrcategary = ({ goalId }) => {
    const [categary, setData] = useState([]);
    useEffect(() => {
        service.getOkrPopUpCategary({ id: goalId })
            .then((response:any) => {
                setData(response.data.data);
            })
            .catch((err: any) => {
                console.log('err', err);
            });
    }, []);

    return (
        <>
            {
                categary && categary.length > 0
                    && (
                        <div className="goal-categary">
                            <div data-tip={categary} className="categories">
                                <div className="cate-first-div">
                                    <img alt="" className="cat-img" src={imgUrl('/images/goal/tag_grey.png')} />
                                    {categary}
                                </div>
                            </div>
                            <ReactTooltip />
                        </div>
                    )
            }

        </>
    )
}

export default Okrcategary;
